import { productFilter } from '../types/enums';
import product1 from '../../assets/media/products/product-1.png';
import product2 from '../../assets/media/products/product-2.png';
import product3 from '../../assets/media/products/product-3.png';
import product4 from '../../assets/media/products/product-4.png';
import product5 from '../../assets/media/products/product-5.png';
import product6 from '../../assets/media/products/product-6.png';
import product7 from '../../assets/media/products/product-7.png';
import product8 from '../../assets/media/products/product-8.png';
import product9 from '../../assets/media/products/product-9.png';
import product10 from '../../assets/media/products/product-10.png';
import product11 from '../../assets/media/products/product-11.png';
import product12 from '../../assets/media/products/product-12.png';
import product13 from '../../assets/media/products/product-13.png';
import product14 from '../../assets/media/products/product-14.png';
import product15 from '../../assets/media/products/product-15.png';
import product16 from '../../assets/media/products/product-16.png';
import product17 from '../../assets/media/products/product-17.png';
import product18 from '../../assets/media/products/product-18.png';
import product19 from '../../assets/media/products/product-19.png';
import product20 from '../../assets/media/products/product-20.png';
import product21 from '../../assets/media/products/product-21.png';
import product22 from '../../assets/media/products/product-22.png';
import product23 from '../../assets/media/products/product-23.png';
import product24 from '../../assets/media/products/product-24.png';
import product25 from '../../assets/media/products/product-25.png';

const products: Iproduct[] = [
  {
    id: 24,
    image: product24,
    name: 'Limoncello',
    label: 'Ликёр',
    descr: 'Выразительный, с преобладанием свежей лимонной цедры.',
    bigDescr: 'Santo Stefano Limoncello – солнечный ликер с насыщенным ароматом лимонной цедры, мягкой сладостью во вкусе, шелковистой текстурой и освежающим цитрусовым послевкусием. Идеален охлаждённым - в чистом виде или в составе коктейлей.',
    color: 'Яркий золотисто-жёлтый, с солнечными отблесками.',
    taste: 'Мягкий и сладкий, с яркой лимонной свежестью и лёгкой кислинкой. Послевкусие долгое и освежающее, с нотами лимонной кожуры и лёгкой горчинкой.',
    alcohol: '',
    type: '',
    tag: productFilter.LIKYORY
  },
  {
    id: 19,
    image: product19,
    name: 'Bianco Amabile (0.25)',
    label: 'Игристое',
    descr: 'Свежий и насыщенный, с медово-мускатными оттенками',
    bigDescr: 'Santo Stefano Bianco Amabile - напиток с утонченным мускатным ароматом и нотками меда. Отлично подходит как в качестве аперитива, так и сопровождения твердых и полутвердых сыров, суши, белого винограда. Подавать охлажденным до 8-10С в бокалах "Тюльпанах" или высоких узких фужерах.',
    color: 'От нежно-соломенного до золотистого',
    taste: 'Яркий вкус с умеренной сладостью и долгим послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 20,
    image: product20,
    name: 'Rose Amabile (0.25)',
    label: 'Игристое',
    descr: 'Свежий и элегантный с тонами земляники, красных ягод и цветов ',
    bigDescr: 'Santo Stefano Bianco Amabile – напиток обладает приятным нежным ароматом земляники, красных ягод и цветов. Идеально сочетается с  фруктовым и сырным канапе, хрустящими хлебцами, лимонным пирогом, спелой клубникой. Подавать охлажденным до 8-10С в бокалах "Тюльпанах" или высоких узких фужерах.',
    color: 'От светло-розового до розового',
    taste: 'Мягкий и утонченный, с нежным сбалансированным послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 21,
    image: product21,
    name: 'Matrimonio Siciliano (0.25)',
    label: 'Игристое',
    descr: 'Многогранный с нотками спелого сицилийского  персика и абрикоса',
    bigDescr: 'Santo Stefano Matrimonio Siciliano (Сицилийская Свадьба) – это утонченный аромат с нотками сицилийского спелого персика и абрикоса. Идеально сочетается с фруктовым салатом, сырной фокаччей, сухариками «Бискотти»',
    color: 'От светло-соломенного до золотистого',
    taste: 'Нежный и сбалансированный, с отличным сочным послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 22,
    image: product22,
    name: 'Vacanze Romane (0.25)',
    label: 'Игристое',
    descr: 'Утонченный с нотками ванили',
    bigDescr: 'Santo Stefano Vacanze Romane (Римские Каникулы) – свежий, сбалансированный напиток, с приятным, нежным ванильным послевкусием. Освежающий вкус итальянского пломбира делает напиток прекрасным компаньоном для фруктов, хлебных палочек с кунжутом, ванильного бисквита',
    color: 'От светло-соломенного до золотистого',
    taste: 'Оригинальный вкус джелато с долгим послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 23,
    image: product23,
    name: 'Rosso Amabile (0.25)',
    label: 'Игристое',
    descr: 'Утонченное сочетание клубники и ванили',
    bigDescr: 'Santo Stefano Rosso Amabile - напиток с утонченными нотками клубники и ванили. Напиток идеален  в качестве дижестива и аперитива. Отличное сопровождение к хрустящим брускеттам с клубникой и сыром фета, блинчиками. Подавать охлажденным до 8-10С в бокалах "Тюльпанах" или высоких узких фужерах.',
    color: 'Нежно-рубиновый',
    taste: 'Полный и насыщенный вкус с ягодными нотами',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 13,
    image: product13,
    name: 'Brut',
    label: 'Игристое',
    descr: 'Натуральный аромат винограда белых сортов',
    bigDescr: 'Santo Stefano Brut – яркий и аутентичный Игристый Брют от легендарного Санто Стефано. Легкое и свежее вино, которым можно наслаждаться как самостоятельно, так и в сочетании с различными блюдами. Игристое вино произведено по технологии Шармá-Мартинотти.',
    color: 'От золотистого до пшеничного',
    taste: 'Мягкий вкус с освежающим всплеском пузырьков',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 14,
    image: product14,
    name: 'Brut Rose',
    label: 'Игристое',
    descr: 'Натуральный аромат винограда белых и красных сортов',
    bigDescr: 'Santo Stefano Brut Rose – яркий и аутентичный Игристый Брют от легендарного Санто Стефано. Легкое и свежее вино, которым можно наслаждаться как самостоятельно, так и в сочетании с различными блюдами. Игристое вино произведено по технологии Шармá-Мартинотти.',
    color: 'От глубокого розового до бледно-рубинового',
    taste: 'Мягкий вкус с освежающим всплеском пузырьков',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 6,
    image: product6,
    name: 'Bianco Amabile',
    label: 'Игристое',
    descr: 'Свежий и насыщенный, с медово-мускатными оттенками',
    bigDescr: 'Santo Stefano Bianco Amabile - напиток с утонченным мускатным ароматом и нотками меда. Отлично подходит как в качестве аперитива, так и сопровождения твердых и полутвердых сыров, суши, белого  винограда. Подавать охлажденным до 8-10С в бокалах "Тюльпанах" или высоких узких фужерах.',
    color: 'От нежно-соломенного до золотистого',
    taste: 'Яркий вкус с умеренной сладостью и долгим послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 7,
    image: product7,
    name: 'Rose Amabile',
    label: 'Игристое',
    descr: 'Свежий и элегантный с тонами земляники, красных ягод и цвето',
    bigDescr: 'Santo Stefano Rose Amabile – напиток обладает приятным нежным ароматом земляники, красных ягод и цветов. Идеально сочетается с фруктовым и сырным канапе, хрустящими хлебцами, лимонным пирогом, спелой клубникой. Подавать охлажденным до 8-10С в бокалах "Тюльпанах" или высоких узких фужерах.',
    color: 'От светло-розового до розового',
    taste: 'Мягкий и утонченный, с нежным сбалансированным послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 8,
    image: product8,
    name: 'Rosso Amabile',
    label: 'Игристое',
    descr: 'Утонченное сочетание клубники и ванили',
    bigDescr: 'Santo Stefano Rosso Amabile - напиток с утонченными нотками клубники и ванили. Напиток идеален  в качестве дижестива и аперитива. Отличное сопровождение к хрустящим брускеттам с клубникой и сыром фета, блинчиками. Подавать охлажденным до 8-10С в бокалах "Тюльпанах" или высоких узких фужерах.',
    color: 'Нежно-рубиновый',
    taste: 'Полный и насыщенный вкус с ягодными нотами',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 9,
    image: product9,
    name: 'Matrimonio Siciliano',
    label: 'Игристое',
    descr: 'Многогранный с нотками спелого сицилийского  персика и абрикоса',
    bigDescr: 'Santo Stefano Matrimonio Siciliano (Сицилийская Свадьба) – это утонченный аромат с нотками сицилийского спелого персика и абрикоса. Идеально сочетается с фруктовым салатом, сырной фокаччей, сухариками «Бискотти».',
    color: 'От светло-соломенного до золотистого',
    taste: 'Нежный и сбалансированный, с отличным сочным послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 10,
    image: product10,
    name: 'Vacanze Romane',
    label: 'Игристое',
    descr: 'Утонченный с нотками ванили',
    bigDescr: 'Santo Stefano Vacanze Romane (Римские Каникулы) – свежий, сбалансированный напиток, с приятным, нежным ванильным послевкусием. Освежающий вкус итальянского пломбира делает напиток прекрасным компаньоном для фруктов, хлебных палочек с кунжутом, ванильного бисквита.',
    color: 'От светло-соломенного до золотистого',
    taste: 'Оригинальный вкус джелато с долгим послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 12,
    image: product12,
    name: 'Bianco Semisecco',
    label: 'Игристое',
    descr: 'Насыщенный цветочно-фруктовый',
    bigDescr: 'Santo Stefano Bianco Semisecco - напиток с узнаваемым медово-цветочным ароматом белого муската, так любимого почитателями винограда из местечка Асти. С напитком прекрасно сочетаются твердые и полутвердые сыры, тонкая Гавайская пицца, фруктово-сырная тарелка.',
    color: 'От светло-соломенного до золотистого',
    taste: 'Нежный, сбалансированный с мягким послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 11,
    image: product11,
    name: 'Aperini Spritz',
    label: 'Игристое',
    descr: 'Насыщенные ноты апельсиновой цедры с благородными травянисто-древесными оттенками',
    bigDescr: 'Santo Stefano Aperini Spritz (Аперини Шприц) – игристый, оранжевый напиток со вкусом сладких сицилийских апельсинов и пикантной горчинкой хинного дерева. Обладает пьянящим ароматом апельсиновой цедры с благородными травянисто-древесными нотами. Идеально сочетается с итальянскими снеками: брускетты с разнообразными топпингами, чесночные фокаччи, тонкие слайсы вяленого мяса, фруктовые пиццы.',
    color: 'Яркий красно-оранжевый',
    taste: 'Цитрусовый и темпераментный, с легкой пикантной горчинкой',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 25,
    image: product25,
    name: 'Storie Veneziane',
    label: 'Игристое',
    descr: 'Душистые лесные ягоды, ежевика, лёгкая клюквенная кислинка',
    bigDescr: 'Santo Stefano Storie Veneziane — легкий игристый напиток с насыщенным вкусом лесных ягод, спелой ежевики и клюквы. Глубокий рубиновый цвет, выразительный ягодный аромат и мягкое послевкусие.',
    color: 'Глубокий рубиновый',
    taste: 'Насыщенный ягодный, с мягким освежающим послевкусием',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.SPARKLING
  },
  {
    id: 4,
    image: product4,
    name: 'Bianco Zero',
    label: 'Безалкогольное',
    descr: 'Аромат белого винограда с оттенками муската и лёгкой фруктовой свежестью',
    bigDescr: 'Santo Stefano Bianco Zero — безалкогольное игристое с ароматом тосканского муската и тонкой фруктовой свежестью. Лёгкий перляж подчёркивает естественную сладость и завершается чистым цитрусовым послевкусием.<br/> Идеально для аперитива. Подходит к лёгким салатам, закускам с морепродуктами и мягким сырам. Подавайте охлаждённым до 8–10°C.',
    color: 'Светло-золотистый с искристым блеском',
    taste: 'Гармоничный, со свежей фруктовой сладостью, мускатно-цветочными акцентами и чистым цитрусовым послевкусием',
    alcohol: '0 градусов',
    type: 'Полусладкое',
    tag: productFilter.NON_ALCOHOLIC
  },
  {
    id: 5,
    image: product5,
    name: 'Rosso Zero',
    label: 'Безалкогольное',
    descr: 'Аромат винограда красных сортов с фруктово-ягодными акцентами',
    bigDescr: 'Santo Stefano Rosso Zero — безалкогольное игристое с ярким вкусом соррентийского винограда и лёгкими ягодными акцентами. Игривый перляж раскрывает полноту вкуса и оставляет свежее выразительное послевкусие.<br/> Идеально для аперитива. Подходит к пасте, мясным нарезкам и ягодным десертам. Подавайте охлаждённым до 8–10°C.',
    color: 'Рубиново-красный',
    taste: 'Выразительный вкус соррентийского винограда с ягодными оттенками и утончённой игристостью',
    alcohol: '0 градусов',
    type: 'Полусладкое',
    tag: productFilter.NON_ALCOHOLIC
  },
  {
    id: 18,
    image: product18,
    name: 'Brut Rose Zero',
    label: 'Безалкогольное',
    descr: 'Чистый и лёгкий аромат с оттенками ягод и цветов',
    bigDescr: 'Santo Stefano Brut Rosé Zero — безалкогольное игристое с тонкой фруктовой сладостью и изящным цветочно-ягодным ароматом. Лёгкий перляж подчёркивает свежесть, а послевкусие раскрывается минеральными нюансами и лёгкой ягодной кислинкой. Идеально для аперитива. Подходит к лёгким закускам, салатам и морепродуктам. Подавайте охлаждённым до 8–10°C.',
    color: 'Нежно-розовый с благородным лососевым оттенком',
    taste: 'Чистый с деликатной фруктовой сладостью, цитрусовой свежестью и минерально-ягодным послевкусием',
    alcohol: '0 градусов',
    type: 'Полусладкое',
    tag: productFilter.NON_ALCOHOLIC
  },
  {
    id: 15,
    image: product15,
    name: 'Bianco Zero<br />(0.25 L)',
    label: 'Безалкогольное',
    descr: 'Аромат белого винограда с оттенками муската и лёгкой фруктовой свежестью',
    bigDescr: 'Santo Stefano Bianco Zero — безалкогольное игристое с ароматом тосканского муската и тонкой фруктовой свежестью. Лёгкий перляж подчёркивает естественную сладость и завершается чистым цитрусовым послевкусием.<br/> Идеально для аперитива. Подходит к лёгким салатам, закускам с морепродуктами и мягким сырам. Подавайте охлаждённым до 8–10°C.',
    color: 'Светло-золотистый с искристым блеском',
    taste: 'Гармоничный, со свежей фруктовой сладостью, мускатно-цветочными акцентами и чистым цитрусовым послевкусием',
    alcohol: '0 градусов',
    type: 'Полусладкое',
    tag: productFilter.NON_ALCOHOLIC
  },
  {
    id: 16,
    image: product16,
    name: 'Rosso Zero<br />(0.25 L)',
    label: 'Безалкогольное',
    descr: 'Аромат винограда красных сортов с фруктово-ягодными акцентами',
    bigDescr: 'Santo Stefano Rosso Zero — безалкогольное игристое с ярким вкусом соррентийского винограда и лёгкими ягодными акцентами. Игривый перляж раскрывает полноту вкуса и оставляет свежее выразительное послевкусие.<br/>Идеально для аперитива. Подходит к пасте, мясным нарезкам и ягодным десертам. Подавайте охлаждённым до 8–10°C.',
    color: 'Рубиново-красный',
    taste: 'Выразительный вкус соррентийского винограда с ягодными оттенками и утончённой игристостью',
    alcohol: '0 градусов',
    type: 'Полусладкое',
    tag: productFilter.NON_ALCOHOLIC
  },
  {
    id: 17,
    image: product17,
    name: 'Brut Rose Zero<br />(0.25 L)',
    label: 'Безалкогольное',
    descr: 'Чистый и лёгкий аромат с оттенками ягод и цветов',
    bigDescr: 'Santo Stefano Brut Rosé Zero — безалкогольное игристое с тонкой фруктовой сладостью и изящным цветочно-ягодным ароматом. Лёгкий перляж подчёркивает свежесть, а послевкусие раскрывается минеральными нюансами и лёгкой ягодной кислинкой.<br/> Идеально для аперитива. Подходит к лёгким закускам, салатам и морепродуктам. Подавайте охлаждённым до 8–10°C.',
    color: 'Нежно-розовый с благородным лососевым оттенком',
    taste: 'Чистый с деликатной фруктовой сладостью, цитрусовой свежестью и минерально-ягодным послевкусием',
    alcohol: '0 градусов',
    type: 'Полусладкое',
    tag: productFilter.NON_ALCOHOLIC
  },
  {
    id: 1,
    image: product1,
    name: 'Bianco',
    label: 'Аперитив',
    descr: 'Выразительный аромат с оттенками цитрусов и цветов, дополненный пряной травяной свежестью',
    bigDescr: 'Классический аперитив Santo Stefano Bianco, созданный по традиционному итальянскому рецепту. Идеален в чистом виде со льдом и долькой лайма или в составе коктейлей.',
    color: 'Светло-соломенный с лёгким золотистым отблеском',
    taste: 'Мягкая пряная сладость, лёгкая горчинка полыни и освежающая кислинка в послевкусии',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.VERMOUTH
  },
  {
    id: 2,
    image: product2,
    name: 'Aperini',
    label: 'Аперитив',
    descr: 'Пикантный аромат с акцентом на красные апельсины, дополненный пряными и травяными нюансами',
    bigDescr: 'Культовый цитрусовый аперитив Santo Stefano Aperini, созданный по традиционному итальянскому рецепту. Идеален в чистом виде со льдом и долькой апельсина или в составе коктейлей.',
    color: 'Сочный красно-оранжевый',
    taste: 'Насыщенный и структурный, с сочными сицилийскими апельсинами, пряными оттенками аниса и кардамона и деликатной горчинкой полыни',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.VERMOUTH
  },
  {
    id: 3,
    image: product3,
    name: 'Rosato',
    label: 'Аперитив',
    descr: 'Чистый аромат красных ягод с изысканным травяным акцентом',
    bigDescr: 'Розовый аперитив Santo Stefano Rosato, созданный по традиционному итальянскому рецепту. Идеален в чистом виде со льдом или в составе коктейлей.',
    color: 'Нежно-розовый',
    taste: 'Сбалансированный и освежающий, с сочной сладостью клубники и земляники, оттенённой лёгкой травяной горчинкой',
    alcohol: '8 градусов',
    type: 'Полусладкое',
    tag: productFilter.VERMOUTH
  }
];

export default products;